import { NgModule, APP_INITIALIZER, ErrorHandler, ApplicationRef, NgZone } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { APP_BASE_HREF } from '@angular/common';
import { HttpHeaders, HttpResponseBase, HttpRequest, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { LoginModule } from './authentication/login/login.module';
import { SharedModule } from './shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { AuthGuard } from './shared/auth.guard';
import { RolesGuard } from './shared/roles.gaurd';
import { HttpClientService } from './shared/http-client-service';
import { LoginService } from './authentication/login/services/login.service';
import { RegistrationService } from './ext-user-management/registration/services/registration.service';
// import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
// import { NgIdleModule, NgIdleKeepaliveModule } from 'ngx-idle';
// import { NgIdleModule } from 'ngx-idle';
import { ConfigService } from './config/config.service';
import { BlockUIService } from './shared/services/blockui.service';
import { VersionCheckService } from './shared/services/version-check.service';
import { NotificationService } from './shared/services/notification.service';
import { GlobalVariableServices } from './shared/sharedservices/globalvariable.services';
import { RolesPermissionsService } from './shared/services/rolespermissions.service';
import { GlobalExceptionHandler } from './shared/BaseComponent/FetchErrorHandler';
import { SessionService } from './shared/services/session.service';
//import { ToastsManager } from 'ngx-toastr/src/toast-manager';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmationService } from 'primeng/api';
import { AppRoutingModule } from './app-routing.module';
//redux
// import { NgReduxModule, NgRedux, DevToolsExtension } from '@angular-redux/store';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './study-site-wizard/studysitewizard.reducer';
import { RegistrationModule } from './ext-user-management/registration/registration.module';
import { ExtLoginService } from './authentication/login/services/extlogin.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ColorPickerModule } from 'primeng/colorpicker';
@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        AppRoutingModule,
        ToastrModule.forRoot(),
        BrowserAnimationsModule,
        SharedModule.forRoot(),
        // NgIdleKeepaliveModule.forRoot(),
        // NgIdleModule.forRoot(),
        // NgIdleKeepaliveModule.forRoot(),
        // NgxInactivity.forRoot(),
        StoreModule.forRoot(reducers, { metaReducers }),
        // InlineEditorModule, //#viracor futureuse
        LoginModule,
        DialogModule,
        InputTextareaModule,
        ProgressSpinnerModule,
        RegistrationModule,
        ColorPickerModule,
        MultiSelectModule], providers: [
        AuthGuard,
        RolesGuard,
        { provide: APP_BASE_HREF, useValue: '' },
        HttpClientService,
        LoginService,
        ConfigService,
        // NgReduxModule,
        BlockUIService,
        VersionCheckService,
        NotificationService,
        GlobalVariableServices,
        RolesPermissionsService,
        SessionService,
        RegistrationService,
        ExtLoginService,
        //   { provide: DevToolsExtension, useClass: DevToolsExtension, deps: [ApplicationRef, NgRedux] }, // add static provider
        // { provide: NgRedux, useFactory: () => new NgZone({}), deps: [NgZone] },
        { provide: APP_INITIALIZER, useFactory: (config: ConfigService) => () => config.load(), deps: [ConfigService], multi: true },
        {
            provide: ErrorHandler, useClass: GlobalExceptionHandler
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
